var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPvp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4678 0.743042C27.7782 0.743042 28.085 0.866905 28.2998 1.09753H28.2988C28.516 1.32351 28.6338 1.62795 28.6182 1.94226L28.3857 8.94812C28.3774 9.26987 28.2287 9.58176 27.9785 9.79285L12.6309 23.1688L12.6279 23.1708C12.4724 23.3017 12.2787 23.3798 12.0723 23.3798C11.8513 23.3797 11.6407 23.2935 11.4756 23.1366L11.4717 23.1337V23.1327L6.23438 17.8964C5.92121 17.5832 5.90411 17.0759 6.19336 16.744L19.5771 1.38074C19.7901 1.12969 20.0951 0.991796 20.417 0.97644H20.4199L27.4287 0.743042H27.4678Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4557 1.5898L20.4466 1.82257C20.3561 1.82257 20.2785 1.86784 20.2203 1.93249L6.83594 17.289L12.0733 22.5263L27.4298 9.14842C27.4944 9.09023 27.5397 9.00617 27.5397 8.92212L27.7789 1.9131C27.7854 1.73205 27.6367 1.58334 27.4557 1.5898Z",
    fill: "url(#paint0_linear_759_4164)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4302 9.1484L12.0738 22.5328L9.45508 19.9141L27.6889 1.6803C27.7471 1.73849 27.7859 1.82255 27.7794 1.9066L27.5466 8.92209C27.5402 9.01261 27.5014 9.09667 27.4302 9.1484Z",
    fill: "url(#paint1_linear_759_4164)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49733 26.7163C5.32922 26.7163 5.16757 26.6516 5.03826 26.5288L2.83985 24.3304C2.717 24.2075 2.65234 24.0459 2.65234 23.8713C2.65234 23.6967 2.717 23.5351 2.83985 23.4122L6.57714 19.6749C6.69999 19.5456 6.8681 19.4874 7.03621 19.4874C7.20433 19.4874 7.36597 19.5521 7.49529 19.6749L9.69369 21.8733C9.94586 22.1255 9.94586 22.5329 9.69369 22.785L5.95641 26.5223C5.82709 26.6516 5.65898 26.7163 5.49733 26.7163Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02964 20.1404L9.22805 22.3323L5.49723 26.0696L3.29883 23.8712L7.02964 20.1404Z",
    fill: "url(#paint2_linear_759_4164)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12925 21.2332L9.22846 22.3324L5.49764 26.0696L4.39844 24.9704L8.12925 21.2332Z",
    fill: "url(#paint3_linear_759_4164)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90723 22.2356C4.76832 22.2357 5.58207 22.5736 6.18848 23.1799L6.30273 23.301C7.41124 24.528 7.41216 26.4026 6.30273 27.6243L6.18848 27.7434C5.58206 28.3498 4.76839 28.6877 3.90723 28.6877C3.09967 28.6877 2.33355 28.3907 1.74121 27.8538L1.625 27.7434C1.01868 27.137 0.680751 26.3233 0.680664 25.4622C0.680664 24.6009 1.0185 23.7864 1.625 23.1799L1.74121 23.0696C2.33352 22.5327 3.09974 22.2356 3.90723 22.2356Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90679 27.8413C5.22092 27.8413 6.28624 26.776 6.28624 25.4618C6.28624 24.1477 5.22092 23.0824 3.90679 23.0824C2.59266 23.0824 1.52734 24.1477 1.52734 25.4618C1.52734 26.776 2.59266 27.8413 3.90679 27.8413Z",
    fill: "url(#paint4_linear_759_4164)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22656 27.143C3.15765 28.0741 4.6642 28.0741 5.59529 27.143C6.52638 26.2119 6.52638 24.7054 5.59529 23.7743L2.22656 27.143Z",
    fill: "url(#paint5_linear_759_4164)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08887 13.8475C5.63974 13.8475 6.14416 14.0581 6.53418 14.4481L14.9268 22.8407L15.0664 22.995C15.6757 23.742 15.6755 24.8211 15.0664 25.5682L14.9268 25.7235L13.9502 26.6991L13.9492 26.7001C13.1579 27.4846 12.1049 27.9131 10.9932 27.9198H10.9922C9.9488 27.9197 8.9577 27.5371 8.19141 26.8427L8.04199 26.6991C7.73124 26.3883 7.73124 25.8868 8.04199 25.576L9.33203 24.285L5.08887 20.035L3.79883 21.326C3.64681 21.4781 3.44627 21.5575 3.2334 21.5575C3.04712 21.5575 2.87061 21.4968 2.72754 21.3798L2.66797 21.326C1.87691 20.5348 1.44727 19.4876 1.44727 18.3749C1.44738 17.2622 1.88363 16.2092 2.66797 15.4247L3.64453 14.4481L3.79395 14.3124C4.15582 14.014 4.60652 13.8476 5.08887 13.8475Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3567 23.3993C14.8416 23.8842 14.8416 24.673 14.3567 25.158L13.3804 26.1343C12.0613 27.4534 9.9211 27.4534 8.60206 26.1343L10.0181 24.7183C10.2638 24.4726 10.2638 24.0846 10.0181 23.8389L5.53076 19.3516C5.28506 19.1059 4.89711 19.1059 4.6514 19.3516L3.23537 20.7676C1.91633 19.4486 1.91633 17.3084 3.23537 15.9893L4.21172 15.013C4.69667 14.5281 5.4855 14.5281 5.97044 15.013L14.3567 23.3993Z",
    fill: "url(#paint6_linear_759_4164)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77344 21.5953L10.0171 23.8389C10.2628 24.0846 10.2628 24.4726 10.0171 24.7183L8.60107 26.1343C9.92011 27.4534 12.0603 27.4534 13.3794 26.1343L14.3557 25.158C14.8407 24.673 14.8407 23.8842 14.3557 23.3992L10.1658 19.2029L7.77344 21.5953Z",
    fill: "url(#paint7_linear_759_4164)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27637 0.693237L11.2852 0.925659L11.2842 0.926636C11.6189 0.935032 11.9426 1.0885 12.1631 1.34753H12.1641L25.5488 16.704H25.5479C25.8436 17.0419 25.8366 17.5298 25.5625 17.8612L25.5049 17.9247L20.2705 23.1571L20.2715 23.1581C20.0988 23.3397 19.8638 23.4296 19.6377 23.4296C19.4324 23.4296 19.2162 23.3581 19.0439 23.204V23.203L3.69336 9.83093L3.60059 9.74402C3.39645 9.53143 3.27635 9.25037 3.26855 8.95007L3.03516 1.94128V1.93835C3.02716 1.61414 3.14882 1.29911 3.36719 1.06433L3.37109 1.06042L3.46094 0.97644C3.6794 0.792839 3.95752 0.693237 4.23633 0.693237H4.27637Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25514 1.5898L11.2642 1.82257C11.3547 1.82257 11.4323 1.86784 11.4905 1.93249L24.8684 17.289L19.631 22.5263L4.27454 9.14842C4.20988 9.09023 4.16462 9.00617 4.16462 8.92212L3.93184 1.9131C3.92538 1.73205 4.07409 1.58334 4.25514 1.5898Z",
    fill: "url(#paint8_linear_759_4164)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2815 9.1484L19.638 22.5263L22.2567 19.9076L4.02287 1.6803C3.96467 1.73849 3.92588 1.82255 3.93234 1.9066L4.16511 8.92209C4.17158 9.01261 4.21038 9.09667 4.2815 9.1484Z",
    fill: "url(#paint9_linear_759_4164)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2136 26.7163C26.0455 26.7163 25.8774 26.6516 25.7545 26.5288L22.0173 22.7915C21.7651 22.5393 21.7651 22.132 22.0173 21.8798L24.2157 19.6814C24.345 19.5521 24.5066 19.4939 24.6747 19.4939C24.8428 19.4939 25.0045 19.5586 25.1338 19.6814L28.8711 23.4187C28.9939 23.5415 29.0586 23.7032 29.0586 23.8778C29.0586 24.0523 28.9939 24.214 28.8711 24.3368L26.6727 26.5352C26.5498 26.6452 26.3882 26.7163 26.2136 26.7163Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4116 23.8712L26.2132 26.0696L22.4824 22.3323L24.6744 20.1404L28.4116 23.8712Z",
    fill: "url(#paint10_linear_759_4164)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3124 24.9704L26.2132 26.0696L22.4824 22.3324L23.5816 21.2396L27.3124 24.9704Z",
    fill: "url(#paint11_linear_759_4164)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8047 22.2356C28.666 22.2356 29.4804 22.5734 30.0869 23.1799L30.1973 23.2961C30.7342 23.8885 31.0312 24.6547 31.0312 25.4622C31.0312 26.3232 30.6932 27.137 30.0869 27.7434C29.4804 28.3499 28.666 28.6877 27.8047 28.6877C26.9973 28.6877 26.2319 28.3906 25.6396 27.8538L25.5234 27.7434C24.2624 26.4823 24.2616 24.4351 25.5234 23.1799L25.6396 23.0696C26.2319 22.5329 26.9974 22.2357 27.8047 22.2356Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8033 27.8413C29.1174 27.8413 30.1827 26.776 30.1827 25.4618C30.1827 24.1477 29.1174 23.0824 27.8033 23.0824C26.4891 23.0824 25.4238 24.1477 25.4238 25.4618C25.4238 26.776 26.4891 27.8413 27.8033 27.8413Z",
    fill: "url(#paint12_linear_759_4164)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.485 27.143C28.5539 28.0741 27.0474 28.0741 26.1163 27.143C25.1852 26.2119 25.1852 24.7054 26.1163 23.7743L29.485 27.143Z",
    fill: "url(#paint13_linear_759_4164)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6279 13.7977C27.1853 13.7978 27.7079 14.0134 28.1074 14.413L29.084 15.3885L29.2295 15.5419C29.9371 16.3221 30.3192 17.3193 30.3193 18.3749C30.3193 19.4308 29.9314 20.4343 29.2285 21.2098L29.084 21.3622C28.9223 21.5238 28.7089 21.6083 28.4834 21.6083C28.2925 21.6083 28.1002 21.5437 27.9463 21.4188L27.8828 21.3622L26.6211 20.1053L22.4482 24.2782L23.7041 25.5341L23.7617 25.5966C23.8862 25.7488 23.9502 25.9372 23.9502 26.1346C23.9501 26.3319 23.886 26.5196 23.7617 26.6718L23.7041 26.7352C22.91 27.5292 21.8439 27.9706 20.7178 27.9706C19.662 27.9705 18.6593 27.5824 17.8838 26.8798L17.7314 26.7352L16.7549 25.7587C15.9398 24.9435 15.94 23.6208 16.7549 22.8055L25.1475 14.413L25.3018 14.2733C25.6737 13.9679 26.1399 13.7977 26.6279 13.7977Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3559 23.3993C16.871 23.8842 16.871 24.673 17.3559 25.158L18.3322 26.1343C19.6513 27.4534 21.7915 27.4534 23.1105 26.1343L21.6945 24.7183C21.4488 24.4726 21.4488 24.0846 21.6945 23.8389L26.1818 19.3516C26.4275 19.1059 26.8155 19.1059 27.0612 19.3516L28.4772 20.7676C29.7963 19.4486 29.7963 17.3084 28.4772 15.9893L27.5009 15.013C27.0159 14.5281 26.2271 14.5281 25.7421 15.013L17.3559 23.3993Z",
    fill: "url(#paint14_linear_759_4164)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9382 21.5953L21.6945 23.8389C21.4488 24.0846 21.4488 24.4726 21.6945 24.7183L23.1105 26.1343C21.7915 27.4534 19.6513 27.4534 18.3322 26.1343L17.3559 25.158C16.871 24.673 16.871 23.8842 17.3559 23.3992L21.5523 19.2029L23.9382 21.5953Z",
    fill: "url(#paint15_linear_759_4164)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_759_4164",
    x1: 17.3075,
    y1: 22.5296,
    x2: 17.3075,
    y2: 1.58961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_759_4164",
    x1: 18.618,
    y1: 22.5296,
    x2: 18.618,
    y2: 1.68094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_759_4164",
    x1: 6.26408,
    y1: 26.0683,
    x2: 6.26408,
    y2: 20.1384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_759_4164",
    x1: 6.81345,
    y1: 26.068,
    x2: 6.81345,
    y2: 21.2362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C20058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_759_4164",
    x1: 3.90647,
    y1: 27.8413,
    x2: 3.90647,
    y2: 23.0798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_759_4164",
    x1: 4.25672,
    y1: 27.8417,
    x2: 4.25672,
    y2: 23.7769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_759_4164",
    x1: 8.48561,
    y1: 27.1202,
    x2: 8.48561,
    y2: 14.6448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_759_4164",
    x1: 11.2478,
    y1: 27.1207,
    x2: 11.2478,
    y2: 19.2042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_759_4164",
    x1: 14.403,
    y1: 22.5296,
    x2: 14.403,
    y2: 1.58961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_759_4164",
    x1: 13.0938,
    y1: 22.5295,
    x2: 13.0938,
    y2: 1.68094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3D9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41BEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_759_4164",
    x1: 25.4459,
    y1: 26.0675,
    x2: 25.4459,
    y2: 20.1376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_759_4164",
    x1: 24.897,
    y1: 26.0683,
    x2: 24.897,
    y2: 21.2365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_759_4164",
    x1: 27.803,
    y1: 27.8413,
    x2: 27.803,
    y2: 23.0798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_759_4164",
    x1: 27.4549,
    y1: 27.8417,
    x2: 27.4549,
    y2: 23.7769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_759_4164",
    x1: 23.227,
    y1: 27.1202,
    x2: 23.227,
    y2: 14.6448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_759_4164",
    x1: 20.4633,
    y1: 27.1207,
    x2: 20.4633,
    y2: 19.2042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvp);
export default __webpack_public_path__ + "static/media/pvp.d3d1e71da1549c55f98842af22aa00f6.svg";
export { ForwardRef as ReactComponent };